import React, { useEffect, useState } from "react";
import { MdSearch } from "react-icons/md";
import apiCDS from "../../services/apiCDS";
import Container from "../../components/Container";
import LoadingSpinner from "../../components/LoadingSpinner";
import CardsGridContainer from "../../components/CardsGridContainer";
import Banner from "../../components/Banner";
import * as S from "./styles";

export default function Index() {
  const [authors, setAuthors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [authorsFound, setAuthorsFound] = useState([]);
  const [searchInput, setSearchInput] = useState("");

  useEffect(() => {
    const getAuthors = async () => {
      const response = await apiCDS.get("/authors");
      setAuthors(response.data);
      setLoading(false);
    };

    getAuthors();

    return setAuthors([]);
  }, []);

  if (loading) {
    return <LoadingSpinner />;
  }

  const handleSearch = (e) => {
    setSearchInput(e.target.value);

    const filteredAuthors = authors.filter((author) =>
      author.name.toLowerCase().includes(e.target.value.toLowerCase())
    );

    setAuthorsFound(filteredAuthors);
  };

  return (
    <Container type={"clean"}>
      <Banner />
      <h1 className={"authors"}>Professores</h1>
      <S.ProfessorSearchForm>
        <MdSearch />
        <input
          className="authors-search-input"
          name="searchInput"
          value={searchInput}
          placeholder={"Busque por nome ou sobrenome..."}
          onChange={handleSearch}
        />
      </S.ProfessorSearchForm>
      {searchInput ? (
        authorsFound.length > 0 ? (
          <CardsGridContainer
            content={authorsFound}
            link={"/professores"}
            showItemTitle={true}
          />
        ) : (
          <div className="author-not-found-container">
            <p>
              {" "}
              <b>Não encontramos nenhum professor.</b>
              <br /> Tente escrever de outro jeito ou navegue pelo catálogo.
            </p>
          </div>
        )
      ) : (
        <CardsGridContainer
          content={authors}
          link={"/professores"}
          showItemTitle={true}
        />
      )}
    </Container>
  );
}
